const buttonTheme = {
  baseStyle: {
    borderRadius: "xl",
    fontWeight: "700",
    letterSpacing: "-0.01em",
    lineHeight: "1.2",
  },
  sizes: {
    xs: {
      h: "32px",
      minH: "32px",
      px: 3,
      fontSize: "xs",
    },
    md: {
      h: "42px",
      minH: "42px",
      px: 5,
      fontSize: "sm",
    },
    sm: {
      h: "40px",
      minH: "40px",
      px: 4,
      fontSize: "sm",
    },
    lg: {
      h: "44px",
      minH: "44px",
      px: 6,
      fontSize: "sm",
    },
  },
  variants: {
    solid: (props) => ({
      bg: props.colorScheme === "gray" ? "neutral.800" : undefined,
      color: props.colorScheme === "gray" ? "white" : undefined,
      boxShadow: "0 10px 25px rgba(15, 23, 42, 0.08)",
      _hover: {
        transform: "translateY(-1px)",
        boxShadow: "0 16px 30px rgba(15, 23, 42, 0.12)",
      },
      _active: {
        transform: "translateY(0)",
      },
    }),
    outline: {
      borderWidth: "1px",
      bg: "transparent",
      _hover: {
        bg: "blackAlpha.50",
      },
    },
    ghost: {
      borderRadius: "16px",
      _hover: {
        bg: "blackAlpha.50",
      },
    },
  },
  defaultProps: {
    colorScheme: "brand",
    size: "md",
  },
};

export default buttonTheme;
